var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('nested-viewproperty',{attrs:{"date":_vm.date,"scheduleid":_vm.scheduleid,"elements":_vm.elements,"assigned":_vm.assigned},on:{"deleteItem":_vm.deleteItem,"clickItem":_vm.clickItem,"openUrl":_vm.openUrl}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf5559c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procedure/procedure-viewing-elements/element-view-page-ending.vue
// module id = 1352
// module chunks = 0